var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.message)?_c('div',{staticClass:"bg-red-lighter p-2 w-full"},[_c('p',{staticClass:"text-red font-semibold text-sm"},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }